let registerCurrentStep = 1;
const registerFormStepsMapping = {
  first_name: 1,
  last_name: 1,
  gender: 1,
  birthdate: 1,
  school: 1,
  school_name_frontend_only: 1,
  grad_year: 1,
  mobile_phone: 2,
  home_phone: 2,
  address: 2,
  city: 2,
  province: 2,
  country: 2,
  postal_code: 2,
  email: 3,
  password: 3,
  confirm_password: 3,
  store_name: 3,
  deadline: 3,
  isAcceptTermConditions: 3,
}

jQuery(document).ready(function ($) {

  processFormSubmission();
  fillForms();
  
  // Add modal school name Pre-format to ST.
  $(document).on('blur', 'input[name="school[name]"]', function() {
    let value = $(this).val();
    value = preFormatSchoolName(value);
    $(this).val(value);
  });

  storeFormData();

  // Open Bold links in new tab
  // $('a[href*="boldapps.net"]').attr('target', '_blank');

  // Toggle update cart button on quantity update
  $('.template-cart form[action="/cart"] input[name="updates[]"]').on('change', showUpdateCartButton);
  $('.template-cart form[action="/cart"] .custom-number-control').on('click', showUpdateCartButton);

  // Remove form switcher if form successfully submitted
  if ($('body').hasClass('template-page-contact') && window.location.href.indexOf('contact_posted=true') != -1) {
    $('.switch--parent').hide();
  }

  // Unbind events and uncheck product options
  $('.parameters__list input[type=radio]').unbind().prop('checked', false);

  // Hide error on option selection
  $('.parameters__list input[type=radio]').on('change', function () {
    if (this.checked) {
      $(this).closest('.parameters__list').next().fadeOut();
    }
  });

  // Filter carousels on color selection
  $('.parameters--color input[type=radio]').on('change', function () {
    $('.product-carousel__main, .product-carousel__thumbnails-carousel').slick('slickUnfilter').slick('slickFilter', '.product__image--' + this.dataset.handle);
  });

  // Store collection url for link-back in cart
  if ($('body').hasClass('template-collection')) {
    $('.products-block .product').on('click', function () {
      window.localStorage.setItem('lastCollectionLink', window.location.href);
    });
  }

  // Update "Continue shopping" link to lastCollectionLink if available
  if (window.localStorage.getItem('lastCollectionLink')) {
    $('.link--continue-shopping').attr('href', window.localStorage.getItem('lastCollectionLink'));
  }

  // validate product options
  $('form[action="/cart/add"]').on('submit', function (event) {
    let $form = $(this);

    // hide errors
    // $form.find('.parameters__headline--error').hide();

    $form.find('.parameters__list').each(function (i, parameters) {
      let $parameters = $(parameters);

      if (!$parameters.find('input[type=radio]:checked').length) {
        $parameters.next().fadeIn();
        event.preventDefault();
      }
    });
  });

  // Validate School Form
  function validateInput(field) {
    const regex = /^[A-Za-z0-9 &,.']+$/;
    if (regex.test(field.val())) {
      field.removeClass('is-invalid').addClass('is-valid');
      return true;
    } else {
      field.removeClass('is-valid').addClass('is-invalid');
      return false;
    }
  }

  function checkFormValidity() {
    let isValid = true;
    $('#form-add-school input[type="text"]').each(function() {
      if (!validateInput($(this))) {
        isValid = false;
      }
    });

    if (isValid) {
      $('#school-submit-button').removeAttr('disabled');
    } else {
      $('#school-submit-button').attr('disabled', true);
    }
  }

  
  $('#form-add-school input[type="text"]').on('keyup', function() {
    validateInput($(this));
    checkFormValidity();
  });

  // Add school form
  $('#form-add-school').on('submit', function (evt) {
    evt.preventDefault();

    let $form = $(this);

    $.ajax({
      url: $form.attr('action'),
      method: "POST",
      data: $(this).serialize(),
      success: function (resp) {
        $('.form-control--school').val(resp.data.name).prev().val(resp.data.id);
        $('#add_school .modal-close').trigger('click');
      },
      error: function (error) {
        console.error(error);
      }
    });
  });

  // Handle registration form next step
  $('.action-register-next, .action-register-previous').on('click', function (event) {
    let $this = $(this);
    let $form = $this.closest('form');
    let targetStep = $this.hasClass('action-register-next') ? registerCurrentStep + 1 : registerCurrentStep - 1;

    if ($this.hasClass('action-register-next') && !validateRegisterForm($this, registerCurrentStep)) {
      return false;
    }

    if (targetStep == 4) {
      return;
    }

    event.preventDefault();

    $form.find('.step' + registerCurrentStep).fadeOut(250, function () {
      $form.find('.step' + targetStep).fadeIn(250);
    });

    updateRegisterFormElements($form, targetStep);
    registerCurrentStep = targetStep;
  });

  // Fetch school name on #add_school modal open
  $(document).on('click', 'a[href="#add_school"]', function() {
    let schoolName = $('.form-control--school').val();
    $('#add_school input[name="school[name]"]').val(schoolName);
  });

  // Accept school rep terms button
  $(document).on('click', '#btn-school-rep-terms-accept', function() {
    $('#signup-form #isAcceptTermConditions').prop('checked', true).trigger('change');
    $('#school_rep_terms .modal-close').trigger('click');
  });

  // Reject school rep terms button
  $(document).on('click', '#btn-school-rep-terms-reject', function() {
    $('#signup-form #isAcceptTermConditions').removeAttr('checked').trigger('change');
    $('#school_rep_terms .modal-close').trigger('click');
  });
});


//Pre-format Function for school name from ST to ST.
function preFormatSchoolName(str) {
  if (!str) return str;
  str = str.trim();
  str = str.replace(/\bST\b(?!\.)/gi, 'St.');
  str = str.replace(/ST\.+/gi, 'St.');
  return str;
}


jQuery(window).on('load', function($) {
  // scroll to top on successful contact form
  // if (window.location.href.includes('contact_posted=true')) {
  //   setTimeout(function() {
  //       window.scroll(0, 0);
  //   }, 100);
  // }
});

function showUpdateCartButton() {
  $('.cart__update').removeClass('d-none');
  $('.cart__submit.bold_clone').addClass('d-none');
}

function getQueryParams(param) {
  return new URL(window.location.href).searchParams.get(param);
}

function updateRegisterFormElements($form, targetStep) {
  // update step title
  let $stepTitle = $form.closest('.signup-form__holder').find('.signup-form__step');
  $stepTitle.text($stepTitle.data('title-step' + targetStep));

  // update next button label
  if (targetStep === 3) {
    $form.find('.action-register-next span').text('Register');
  } else {
    $form.find('.action-register-next span').text('Next');
  }

  // toggle previous button
  if (targetStep === 1) {
    $form.find('.action-register-previous').css({
      'visibility': 'hidden'
    }).animate({
      opacity: 0
    });
  } else {
    $form.find('.action-register-previous').css({
      'visibility': 'visible'
    }).animate({
      opacity: 1
    });
  }
}

function validateRegisterForm($this, step) {
  let $fields = $this.closest('form').find('.step' + step).find('input, select');
  let validation = true;

  $fields.each(function (i, field) {
    let $field = $(field);
    let $fieldGroup = $field.closest('.form-group');
    let fieldIsValid = true;
    let customMessage = '';

    if ($field.hasClass('datetimepicker-input')) {
      fieldIsValid = field.value.length ? true : false;
    } else if ($field.hasClass('form-control--email')) {
      let email = field.value;

      if (!email.length) {
        fieldIsValid = false;
      } else if (!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(field.value)) {
        fieldIsValid = false;
        customMessage = theme.strings.validEmail;
      }

    } else {
      fieldIsValid = field.checkValidity();
    }

    // validate fields for special patterns
    if (fieldIsValid) {
      if ($field.hasClass('form-control--phone') && $field.val().length) {
        // fieldIsValid = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g.test(field.value);
        let phone = field.value.split('-').join('').split(' ').join('').split('+').join('');

        if (phone.length > 11 || phone.length < 10) {
          fieldIsValid = false;
        } else {
          switch (phone.length) {
            case 11:
              phone = phone.slice(0, 1) + '-' + phone.slice(1, 4) + '-' + phone.slice(4, 7) + '-' + phone.slice(7, 11);
              break;
            case 10:
              phone = phone.slice(0, 3) + '-' + phone.slice(3, 6) + '-' + phone.slice(6, 10);
              break;
          }
        }

        $field.val(phone);

        if ( $field.attr('name') == 'home_phone' ) {
          customMessage = theme.strings.validPhoneHome;
        } else {
          customMessage = theme.strings.validPhoneMobile;
        }

      } else if ($field.hasClass('form-control--email')) {} else if ($field.hasClass('form-control--password')) {
        fieldIsValid = field.value.length >= 6 ? true : false;
        customMessage = theme.strings.passwordRules;
      } else if ($field.hasClass('form-control--confirm-password')) {
        let password = $field.closest('form').find('.form-control--password').val();

        if (password != field.value) {
          fieldIsValid = false;
          customMessage = theme.strings.passwordMatchError;
        }
      } else if ($field.hasClass('form-control--school') && $field.prev().val() == '') {
        fieldIsValid = false;
        customMessage = theme.strings.validSchool;
      } else if ($field.hasClass('form-control--postal_code')) {
        let countryField = $field.closest('form').find('input[name="country"]');
        let country = countryField.val().trim().toLowerCase();
        if (country === 'canada') {
          let postalCode = $field.val().trim(); // Trim spaces from start and end
          // Canadian postal code format: A1A 1A1 (7 characters with a space in the middle)
          if (!/^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/.test(postalCode)) {
            fieldIsValid = false;
            customMessage = 'Please enter a valid postal code (e.g., A1A 1A1)';
            $field.closest('.form-group').addClass('form-group--invalid');
            $field.siblings('.error-message').text(customMessage);
          } else {
            $field.closest('.form-group').removeClass('form-group--invalid');
            $field.siblings('.error-message').text('');
            // Update the field value to ensure spaces are trimmed from start/end
            $field.val(postalCode);
          }
        }
      }
    }

    if (fieldIsValid) {
      $fieldGroup.removeClass('form-group--invalid');
    } else {
      validation = false;

      if (customMessage != '') {
        $fieldGroup.find('.error-message').text(customMessage);
      } else {
        $fieldGroup.find('.error-message').text($fieldGroup.find('.error-message').data('message'));
      }

      $fieldGroup.addClass('form-group--invalid');
    }
  });

  return validation;
}

/**
 * Store form data in localStorage on submit
 */
function storeFormData() {
  $('form[data-slug]').on('submit', function() {
    let formData = {};

    $.each($(this).serialize().split('&'), function (i, item) {
      const parts = item.split('=');

      if (parts[0] == 'password' || parts[0] == 'confirm_password') {
        return;
      }

      formData[parts[0]] = decodeURIComponent(parts[1].replace(/\+/g, '%20'));
   });

    window.localStorage.setItem(this.dataset.slug, JSON.stringify(formData));
  });
}

/**
 * Fill forms with data stored from last session
 * removes password related data
 */
function fillForms() {
  let $form = getForm();

  if (!$form) {
    return false;
  };

  let data = window.localStorage.getItem($form.data('slug'));

  if (!data) {
    return false;
  }

  data = JSON.parse(data);

  Object.keys(data).forEach(function (key) {
    $form.find('[name="' + key + '"]').val(data[key]);
 });
}

function processFormSubmission(type) {
  let $form = getForm()

  if (!$form) {
    return false;
  };

  // error
  let error = getUrlParameter('error');

  if (error) {
    error = JSON.parse(error);

    if ($form.attr('id') == 'login-form--main') {
      $form.find('.error').html(error.error.message).removeClass('d-none');

      return;
    }

    if ($form.attr('id') == 'signup-form') {
      let errorMessages = '';
      let step = 3;

      Object.keys(error).forEach(function(key, i) {
        // errorMessages += (i + 1) + '. ' + error[key] + '<br>';
        $form.find('input[name="' + key + '"]').siblings('.error-message').text(error[key]).show();

        // identify form step
        if ( registerFormStepsMapping.hasOwnProperty(key) && (registerFormStepsMapping[key] < step) ) {
          step = registerFormStepsMapping[key];
        }
      });

      if (step != 1) {
        $form.find('.step1').fadeOut(250, function () {
          $form.find('.step' + step).fadeIn(250);
        });

        registerCurrentStep = step;
      }
      // error = errorMessages;
    } else {
      $form.find('.error').html(error).removeClass('d-none');
    }

    return;
  }

  // message
  let message = getUrlParameter('message');

  if (message) {
    message = JSON.parse(message);
    const $successEl = $form.next().find('.status--success');

    $('.status--success-heading').html('Success');
    $successEl.find('.message').html(message.message);
    $successEl.removeClass('d-none');
    $('.remove-on-success').remove();

    return;
  }

  // error message
  let errorMessage = getUrlParameter('errorMessage');

  if (errorMessage) {
    errorMessage = JSON.parse(errorMessage);
    const $errorEl = $form.next().find('.status--error-msg');
    $('.status--success-heading').addClass('d-none');
    $('.status--error-heading').removeClass('d-none');
    $('.status--error-heading').html('Error');
    $errorEl.find('.error--message').html(errorMessage.error);
    $errorEl.removeClass('d-none');
    $('.remove-on-success').remove();

    return;
  }

  // success
  let success = getUrlParameter('success');

  if (success) {
    $form.find('.success').html(success).removeClass('d-none');
    return;
  }
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, '%20'));
};

function getForm() {
  const location = window.location.href;
  let $form = null;

  if (location.indexOf('/pages/sign-in') >= 0) {
    $form = $('#login-form--main');
  } else if (location.indexOf('/pages/sign-up') >= 0) {
    $form = $('#signup-form');
  } else if (location.indexOf('/pages/reset-password') >= 0) {
    $form = $('#forget-password-form--main');
  }

  return $form;
}

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-remove-item');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const key = btn.getAttribute('data-key');
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      const row = btn.closest('.cart-products__item');
      if (row) row.parentNode.removeChild(row);
      var totalEl = document.querySelector('.total__price .bold_cart_total, .total__price');
      if (totalEl && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        const fallback = document.querySelector('.total__price:not(.bold_cart_total)');
        if (fallback) fallback.textContent = Shopify.formatMoney(cart.total_price);
      }
      location.reload();
    })
    .catch(function (err) {
      console.error('Remove failed', err);
    });
  }, { passive: false });
});
